import { HotelAvailabilityResponse } from "../models/availability/HotelAvailability";
import { LocationAvailabilityResponse } from "../models/availability/LocationsAvailability";

export type UserType = "agent" | "independent" | "business" | "events";
export enum UserTypeEnum { "agent", "independent", "business", "events" }

export const EngineDestinationTypeHotel: number = 0;
export const EngineDestinationTypeLocation: number = 1;


export const emptyLocationAvailabilityResponse: LocationAvailabilityResponse = { hotels: [], locationAvailabilities: [] };
export const emptyHotelAvailabilityResponse: HotelAvailabilityResponse = { hotels: [], hotelAvailabilities: [], crossSellingProducts: [] };

export const PageSize: number = 10;

export const PaymentsMethodsdRefCodeNotPayedNeeded: string[] = ['pho'] // aqui tenemos los metodos de pago que no necesitan ser pagados directamente


export const ErrorStatus = "error";
export const ActiveStatus = "active";
export const CanceledStatus = "canceled";

export const ERROR_PRE_AUTHORIZATION = "ERROR_PRE_AUTHORIZATION";
export const ERROR_SETTLE = "ERROR_SETTLE";
export const CANCELLED_BY_USER = "CANCELLED_BY_USER";


export const BookingStatusInfo = {
  ERROR_PRE_AUTHORIZATION: 'ERROR_PRE_AUTHORIZATION',
  ERROR_FAILED_POSTPONED: 'ERROR_FAILED_POSTPONED',
  ERROR_SETTLE: 'ERROR_SETTLE',
  ERROR_VOIDING: 'ERROR_VOIDING',
  VOID_OK: 'VOID_OK',
  ERROR_PERFORM_BOOKING_CONNECT: 'ERROR_PERFORM_BOOKING_CONNECT',
  CANCELLED_BY_USER: 'CANCELLED_BY_USER',
  ERROR_NOT_REFUNDED: 'ERROR_NOT_REFUNDED',
  REFUNDED_OK: 'REFUNDED_OK',
  REDO_PREAUTHORIZATION_NOT_POSSIBLE: 'REDO_PREAUTHORIZATION_NOT_POSSIBLE',
} as const;

export const GUEST = 'guest';
export const AGENT = 'agent';
export const MINIMUM = 'minimum';
export const TOTAL = 'total';